<template>
  <div class="content">
    <base-header class="pb-6" type="soilmoisture">
      <b-row align-v="center" class="py-4">
        <b-col>
          <h6 class="h2 text-white d-inline-block mb-0 mr-5">Soil Moisture - {{ field_name }} ( {{ current_node }} ) -
            Graph
          </h6>
          <div v-show='loading' class='mab_spinner light right'></div>
        </b-col>
      </b-row>
    </base-header>

    <div class='container-fluid mt--6'>
      <div class='row'>
        <div class='col-md-12'>
          <card body-classes="px-0 py-0">
            <template slot="header">
              <div class='row'>
                <div class='col-md-12'>
                  <base-button :disabled="!node_id || !userCan('Export', 'Soil Moisture', node_id, 'O')"
                    @click.native="exportGraphCSV()" class="btn" size="sm" type="primary" v-b-tooltip.hover.top
                    title="Export device data to a CSV file." icon>
                    Export CSV
                  </base-button>

                  <base-button :disabled="!node_id || !userCan('Edit', 'Soil Moisture', node_id, 'O')"
                    @click.native="goToManage()" class="btn" size="sm" type="primary" v-b-tooltip.hover.top
                    title="Navigate to the soil moisture node's management screen" icon>
                    Manage SM
                  </base-button>

                  <base-button 
                    v-b-modal.modal-sensor_config class="btn" size="sm" type="primary" v-b-tooltip.hover.top
                    title="Configure sensor activity and weightings" icon>
                    Sensor Config
                  </base-button>

                  <b-modal size="md" id="modal-sensor_config" title="Sensor Configuration">
                  
                      {{addWeighting('SM1')}}
                      {{addWeighting('SM2')}}
                      {{addWeighting('SM3')}}
                      {{addWeighting('SM4')}}
                   
                        Soil Moisture
                        <b-row>
                            <b-col>
                                Sensor
                            </b-col>
                            <b-col>
                                Active
                            </b-col>
                            <b-col>
                                Weighting
                            </b-col>
                        </b-row>
                        <b-row v-if="sensor_config.SM1_ENABLED">
                            <b-col>
                                SM1
                            </b-col>
                            <b-col>
                                <b-form-checkbox @change="saveSensorConfigSM" @input="addWeighting('SM1')" size="lg" v-model="sensor_config.SM1_TOGGLE" switch></b-form-checkbox>
                            </b-col>
                            <b-col>
                                <b-form-input v-if="sensor_config.SM1_TOGGLE" placeholder="Weighting %" v-model="sensor_config.SM1_WEIGHTING" @input="addWeighting('SM1')"></b-form-input>
                            </b-col>
                            <b-col>

                            </b-col>
                        </b-row>
                        <b-row v-if="sensor_config.SM2_ENABLED">
                            <b-col>
                                SM2
                            </b-col>
                            <b-col>
                                <b-form-checkbox @change="saveSensorConfigSM" @input="addWeighting('SM')" size="lg" v-model="sensor_config.SM2_TOGGLE" switch></b-form-checkbox>
                            </b-col>
                            <b-col>
                                <b-form-input v-if="sensor_config.SM2_TOGGLE" placeholder="Weighting %" v-model="sensor_config.SM2_WEIGHTING" @input="addWeighting('SM2')"></b-form-input>
                            </b-col>
                            <b-col>

                            </b-col>
                        </b-row>
                        <b-row v-if="sensor_config.SM3_ENABLED">
                            <b-col>
                                SM3
                            </b-col>
                            <b-col>
                                <b-form-checkbox @change="saveSensorConfigSM" @input="addWeighting('SM3')" size="lg" v-model="sensor_config.SM3_TOGGLE" switch></b-form-checkbox>
                            </b-col>
                            <b-col>
                                <b-form-input v-if="sensor_config.SM3_TOGGLE" placeholder="Weighting %" v-model="sensor_config.SM3_WEIGHTING" @input="addWeighting('SM3')"></b-form-input>
                            </b-col>
                            <b-col>

                            </b-col>
                        </b-row>
                        <b-row v-if="sensor_config.SM4_ENABLED">
                            <b-col>
                                SM4
                            </b-col>
                            <b-col>
                                <b-form-checkbox @change="saveSensorConfigSM" @input="addWeighting('SM4')" size="lg" v-model="sensor_config.SM4_TOGGLE" switch></b-form-checkbox>
                            </b-col>
                            <b-col>
                                <b-form-input v-if="sensor_config.SM4_TOGGLE" placeholder="Weighting %" v-model="sensor_config.SM4_WEIGHTING" @input="addWeighting('SM4')"></b-form-input>
                            </b-col>
                            <b-col>

                            </b-col>
                        </b-row>
                        <b-row v-if="sensor_config.SM5_ENABLED">
                            <b-col>
                                SM5
                            </b-col>
                            <b-col>
                                <b-form-checkbox @change="saveSensorConfigSM" @input="addWeighting('SM5')" size="lg" v-model="sensor_config.SM5_TOGGLE" switch></b-form-checkbox>
                            </b-col>
                            <b-col>
                                <b-form-input v-if="sensor_config.SM5_TOGGLE" placeholder="Weighting %" v-model="sensor_config.SM5_WEIGHTING" @input="addWeighting('SM5')"></b-form-input>
                            </b-col>
                            <b-col>

                            </b-col>
                        </b-row>
                        <b-row v-if="sensor_config.SM6_ENABLED">
                            <b-col>
                                SM6
                            </b-col>
                            <b-col>
                                <b-form-checkbox @change="saveSensorConfigSM" @input="addWeighting('SM6')" size="lg" v-model="sensor_config.SM6_TOGGLE" switch></b-form-checkbox>
                            </b-col>
                            <b-col>
                                <b-form-input v-if="sensor_config.SM6_TOGGLE" placeholder="Weighting %" v-model="sensor_config.SM6_WEIGHTING" @input="addWeighting('SM6')"></b-form-input>
                            </b-col>
                            <b-col>

                            </b-col>
                        </b-row>
                        <b-row v-if="sensor_config.SM7_ENABLED">
                            <b-col>
                                SM7
                            </b-col>
                            <b-col>
                                <b-form-checkbox @change="saveSensorConfigSM" @input="addWeighting('SM7')" size="lg" v-model="sensor_config.SM7_TOGGLE" switch></b-form-checkbox>
                            </b-col>
                            <b-col>
                                <b-form-input v-if="sensor_config.SM7_TOGGLE" placeholder="Weighting %" v-model="sensor_config.SM7_WEIGHTING" @input="addWeighting('SM7')"></b-form-input>
                            </b-col>
                            <b-col>

                            </b-col>
                        </b-row>
                        <b-row v-if="sensor_config.SM8_ENABLED">
                            <b-col>
                                SM8
                            </b-col>
                            <b-col>
                                <b-form-checkbox @change="saveSensorConfigSM" @input="addWeighting('SM8')" size="lg" v-model="sensor_config.SM8_TOGGLE" switch></b-form-checkbox>
                            </b-col>
                            <b-col>
                                <b-form-input v-if="sensor_config.SM8_TOGGLE" placeholder="Weighting %" v-model="sensor_config.SM8_WEIGHTING" @input="addWeighting('SM8')"></b-form-input>
                            </b-col>
                            <b-col>

                            </b-col>
                        </b-row>
                        <b-row v-if="sensor_config.SM9_ENABLED">
                            <b-col>
                                SM9
                            </b-col>
                            <b-col>
                                <b-form-checkbox @change="saveSensorConfigSM" @input="addWeighting('SM')" size="lg" v-model="sensor_config.SM9_TOGGLE" switch></b-form-checkbox>
                            </b-col>
                            <b-col>
                                <b-form-input v-if="sensor_config.SM9_TOGGLE" placeholder="Weighting %" v-model="sensor_config.SM9_WEIGHTING" @input="addWeighting('SM9')"></b-form-input>
                            </b-col>
                            <b-col>

                            </b-col>
                        </b-row>
                        <b-row v-if="sensor_config.SM10_ENABLED">
                            <b-col>
                                SM10
                            </b-col>
                            <b-col>
                                <b-form-checkbox @change="saveSensorConfigSM" @input="addWeighting('SM10')" size="lg" v-model="sensor_config.SM10_TOGGLE" switch></b-form-checkbox>
                            </b-col>
                            <b-col>
                                <b-form-input v-if="sensor_config.SM10_TOGGLE" placeholder="Weighting %" v-model="sensor_config.SM10_WEIGHTING" @input="addWeighting('SM10')"></b-form-input>
                            </b-col>
                            <b-col>

                            </b-col>
                        </b-row>
                        <b-row v-if="sensor_config.SM11_ENABLED">
                            <b-col>
                                SM11
                            </b-col>
                            <b-col>
                                <b-form-checkbox @change="saveSensorConfigSM" @input="addWeighting('SM11')" size="lg" v-model="sensor_config.SM11_TOGGLE" switch></b-form-checkbox>
                            </b-col>
                            <b-col>
                                <b-form-input v-if="sensor_config.SM11_TOGGLE" placeholder="Weighting %" v-model="sensor_config.SM11_WEIGHTING" @input="addWeighting('SM11')"></b-form-input>
                            </b-col>
                            <b-col>

                            </b-col>
                        </b-row>
                        <b-row v-if="sensor_config.SM12_ENABLED">
                            <b-col>
                                SM12
                            </b-col>
                            <b-col>
                                <b-form-checkbox @change="saveSensorConfigSM" @input="addWeighting('SM12')" size="lg" v-model="sensor_config.SM12_TOGGLE" switch></b-form-checkbox>
                            </b-col>
                            <b-col>
                                <b-form-input v-if="sensor_config.SM12_TOGGLE" placeholder="Weighting %" v-model="sensor_config.SM12_WEIGHTING" @input="addWeighting('SM12')"></b-form-input>
                            </b-col>
                            <b-col>

                            </b-col>
                        </b-row>
                        <b-row v-if="sensor_config.SM13_ENABLED">
                            <b-col>
                                SM13
                            </b-col>
                            <b-col>
                                <b-form-checkbox @change="saveSensorConfigSM" @input="addWeighting('SM13')" size="lg" v-model="sensor_config.SM13_TOGGLE" switch></b-form-checkbox>
                            </b-col>
                            <b-col>
                                <b-form-input v-if="sensor_config.SM13_TOGGLE" placeholder="Weighting %" v-model="sensor_config.SM13_WEIGHTING" @input="addWeighting('SM13')"></b-form-input>
                            </b-col>
                            <b-col>

                            </b-col>
                        </b-row>
                        <b-row v-if="sensor_config.SM14_ENABLED">
                            <b-col>
                                SM14
                            </b-col>
                            <b-col>
                                <b-form-checkbox @change="saveSensorConfigSM" @input="addWeighting('SM14')" size="lg" v-model="sensor_config.SM14_TOGGLE" switch></b-form-checkbox>
                            </b-col>
                            <b-col>
                                <b-form-input v-if="sensor_config.SM14_TOGGLE" placeholder="Weighting %" v-model="sensor_config.SM14_WEIGHTING" @input="addWeighting('SM14')"></b-form-input>
                            </b-col>
                            <b-col>

                            </b-col>
                        </b-row>
                        <b-row v-if="sensor_config.SM15_ENABLED">
                            <b-col>
                                SM15
                            </b-col>
                            <b-col>
                                <b-form-checkbox @change="saveSensorConfigSM" @input="addWeighting('SM15')" size="lg" v-model="sensor_config.SM15_TOGGLE" switch></b-form-checkbox>
                            </b-col>
                            <b-col>
                                <b-form-input v-if="sensor_config.SM15_TOGGLE" placeholder="Weighting %" v-model="sensor_config.SM15_WEIGHTING" @input="addWeighting('SM15')"></b-form-input>
                            </b-col>
                            <b-col>

                            </b-col>
                        </b-row>
                        <template #modal-footer>
                          <button class="btn btn-success btn-sm m-1" @click="calculateWeightingSM()">Balance Weighting</button>
                          <button v-b-modal.sensor_config class="btn btn-success btn-sm m-1"
                                  @click="saveSensorConfigSM">
                              Save
                          </button>
                      </template>
                  </b-modal>


                  <b-button v-b-modal.modal-2 size="sm" variant="primary" class="btn" v-b-tooltip.hover.top
                    title="Read More">
                    <b-icon icon="question-circle-fill" aria-label="Help"></b-icon>
                  </b-button>

                    <forecast v-if="this.graph_type == 'ave'" :node_address="current_node"></forecast>
                    <forecast v-if="this.graph_type == 'sum'" :node_address="current_node"></forecast>
                    <forecast v-if="this.graph_type == 'sm'" :node_address="current_node"></forecast>

                  <b-modal id="modal-2" title="Soil Moisture Graph">
                    <h3>Graph Types</h3>
                    <div class="accordion" role="tablist">
                      <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                          <b-button block v-b-toggle.accordion-2 variant="text-left"
                            class="light text-left acc-btn">Separate Levels</b-button>
                        </b-card-header>
                        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                          <b-card-body>
                            <b-card-text>
                              <p>Soil Moisture Separate Levels with average.</p>
                              <p>This graph type has a Zoom mode and Drag mode. If you
                                wish to zoom into the graph just click, hold and move over the area you want to zoom
                                into.
                              </p>
                              <p>Drag mode enables the user to drag the series up or down. Simply click on the toggle
                                button below the graph to enable it.</p>
                              <p>Click on Reset to restore the graph to the original view.</p>
                            </b-card-text>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                      <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                          <b-button block v-b-toggle.accordion-3 variant="text-left"
                            class="light text-left acc-btn">Stacked Graph</b-button>
                        </b-card-header>
                        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                          <b-card-body>
                            <b-card-text>Soil Moisture Separate Levels.</b-card-text>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                      <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                          <b-button block v-b-toggle.accordion-4 variant="text-left"
                            class="light text-left acc-btn">Sum</b-button>
                        </b-card-header>
                        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                          <b-card-body>
                            <b-card-text>Sum of the levels.</b-card-text>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                      <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                          <b-button block v-b-toggle.accordion-5 variant="text-left"
                            class="light text-left acc-btn">Average</b-button>
                        </b-card-header>
                        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                          <b-card-body>
                            <b-card-text>Soil Moisture Average.</b-card-text>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                      <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                          <b-button block v-b-toggle.accordion-6 variant="text-left"
                            class="light text-left acc-btn">Temperature</b-button>
                        </b-card-header>
                        <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                          <b-card-body>
                            <b-card-text>Soil Temperature Average</b-card-text>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                      <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                          <b-button block v-b-toggle.accordion-7 variant="text-left"
                            class="light text-left acc-btn">Technical</b-button>
                        </b-card-header>
                        <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
                          <b-card-body>
                            <b-card-text>Battery Voltage and Ambient Tempeatures.</b-card-text>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                    <div>
                      <h3>Range</h3>
                      <p>Select the date range. They consist of:</p>
                      <p>Last 24 hours</p>
                      <p>Last Week</p>
                      <p>Last Two Weeks</p>
                      <p>Last Month</p>
                      <p>Last Year</p>
                      <p>Custom</p>
                      <h3>Start Date</h3>
                      <p>If you select Custom in the date range dropdown this dropdown will appear. You will be required
                        to select a start date.</p>
                    </div>
                    <div>
                      <h3>Print or Export</h3>
                      <p>A map can be printed in PDF or exported as PNG, JPG, PDF or SVG.</p>
                    </div>
                    <div>
                      <h3>Full and Refill lines</h3>
                      <p>Full (blue): The Full value that applies to the field</p>
                      <p>Refill (red): The Refill value that applies to the field</p>
                      <h3>Series</h3>
                      <p>The series values appear beneath the name of the field. The series display the time and the
                        calculated value of the reading.</p>
                    </div>
                  </b-modal>
                </div>
              </div>
            </template>
            <div class="card-body">
              <b-row>
                <!-- <b-col md="6"> -->
                <b-col md="4" v-if="related_nodes.length > 1">
                  <base-input label="Current Node" v-b-tooltip.hover.top
                    title="The Node Address to which this data record applies to">
                    <el-select @input="loadSensorConfigSM" v-model="current_node" :disabled="loading">
                      <template v-for="(node, index) in related_nodes">
                        <el-option :key="index" :label="node" :value="node"
                          :selected='$route.params.node_address'></el-option>
                      </template>
                    </el-select>
                  </base-input>
                </b-col>

                <b-col md="4">
                  <base-input label="Graph Type">
                    <el-select v-model="graph_type" :disabled="loading" v-b-tooltip.hover.top
                      title="The graph type used when viewing a probe's graph">
                      <el-option label="Separate Levels" value='sm' selected></el-option>
                      <el-option label="Stacked Graph" value='stack'></el-option>
                      <el-option label="Sum" value='sum'></el-option>
                      <el-option label="Average" value='ave'></el-option>
                      <el-option label="Temperature" value='temp'></el-option>
                      <el-option label="Technical" value='tech'></el-option>
                    </el-select>
                  </base-input>
                </b-col>

                <div class="w-100"></div>

                <b-col md="4">
                  <base-input label="Range">
                    <el-select v-model="sub_days" :disabled="loading" v-b-tooltip.hover.top
                      title="Choose the time range of data to view.">
                      <el-option label="Last 24 Hours" value='1'></el-option>
                      <el-option label="Last Week" value='7'></el-option>
                      <el-option label="Last Two Weeks" value='14'></el-option>
                      <el-option label="Last Month" value='31'></el-option>
                      <el-option label="Last Year" value='365'></el-option>
                      <el-option label="Custom" value='custom'></el-option>
                    </el-select>
                  </base-input>
                </b-col>

                <b-col md="4">
                  <base-input v-show="sub_days == 'custom'" label="Start Date">
                    <flat-picker slot-scope="{focus, blur}" @on-open="focus" @on-close="blur" v-model="graph_start_date"
                      :config="{ maxDate: date_now }" placeholder="Custom Date" class="form-control datepicker"
                      v-b-tooltip.hover.top title="A custom start date allows a custom range of data to be viewed.">
                    </flat-picker>
                  </base-input>
                </b-col>
                <!-- </b-col> -->

              </b-row>
              <div class="the_graph">
                <highcharts class="hc" :options="chartOptions" :update-args="chartUpdateArgs" ref="hchart"></highcharts>
              </div>
              <b-row>
                <b-col class='text-center'>
                  <b-form-checkbox v-if="graph_type == 'sm' || graph_type == 'stack'" @change="toggleSeriesDragDrop"
                    v-model="zoomOrDrag" name="check-button" size="lg" switch>Mode: {{ zoomOrDrag ? "Drag" : "Zoom"
                    }}</b-form-checkbox>
                </b-col>
              </b-row>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import { Select, Option } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Highcharts from 'highcharts';
import mab_utils from '../../util/mab-utils';
import NiftyGauge from '../../custom_components/NiftyGauge';
import swal from 'sweetalert2';
 import forecast from '../../components/WeatherForecast';
// Tweak to prevent Tooltip from disappearing (Testing working)
Highcharts.Pointer.prototype.reset = function () { return undefined; };

export default {

  mixins: [mab_utils],

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
      NiftyGauge,
    forecast
  },

  data() {
    return {
      loading: false,
      in_progress: true,

      tooltip: {
        enabled: true,
      },

      sensor_config: {
        SM1_TOGGLE: true,
        SM2_TOGGLE: true,
        SM3_TOGGLE: true,
        SM4_TOGGLE: true,
        SM5_TOGGLE: true,
        SM6_TOGGLE: true,
        SM7_TOGGLE: true,
        SM8_TOGGLE: true,
        SM9_TOGGLE: true,
        SM10_TOGGLE: true,
        SM11_TOGGLE: true,
        SM12_TOGGLE: true,
        SM13_TOGGLE: true,
        SM14_TOGGLE: true,
        SM15_TOGGLE: true,

        SM1_WEIGHTING: 16,
        SM2_WEIGHTING: 16,
        SM3_WEIGHTING: 16,
        SM4_WEIGHTING: 16,
        SM5_WEIGHTING: 16,
        SM6_WEIGHTING: 16,
        SM7_WEIGHTING: 0,
        SM8_WEIGHTING: 0,
        SM9_WEIGHTING: 0,
        SM10_WEIGHTING: 0,
        SM11_WEIGHTING: 0,
        SM12_WEIGHTING: 0,
        SM13_WEIGHTING: 0,
        SM14_WEIGHTING: 0,
        SM15_WEIGHTING: 0,
        
        SM1_ENABLED: true,
        SM2_ENABLED: true,
        SM3_ENABLED: true,
        SM4_ENABLED: true,
        SM5_ENABLED: true,
        SM6_ENABLED: true,
        SM7_ENABLED: false,
        SM8_ENABLED: false,
        SM9_ENABLED: false,
        SM10_ENABLED: false,
        SM11_ENABLED: false,
        SM12_ENABLED: false,
        SM13_ENABLED: false,
        SM14_ENABLED: false,
        SM15_ENABLED: false


      },

      current_node: this.$route.params.node_address,

      node_id: null,
      field_name: null,
      data_grouping: false,


      graph_start_date: '',
      graph_type: '',
      sub_days: '',

      bInitialQuery: true,
      bNotified: false,

      related_nodes: [],

      labelsEnabled: true,
      visible: true,

      reversed: false,

      //data: [],

      date_now: '',
      series: [],
      chartUpdateArgs: [true, true, { duration: 1000 }],
      seriesAdjusted: false,
      zoomOrDrag: false, /* false == zoom, true == drag */
      stacking: 'normal',
      lastDate: null,
      exportFileName: '',

      initial_start_date: null,
      initial_end_date: null,

      selection_start: null,
      selection_end: null,


      yMaxBackup: 0,
      yMinBackup: 0,

      yMin: null,
      yMax: null,

      xMin: 1000,
      xMax: 0,

      lastTimestamp: null,

      full: 0,
      refill: 0,

      status: '',

      plotOptions: {
        series: {
          states: {
            inactive: {
              opacity: 1
            }
          },
        }
      },
      chartTitle: {
        text: "Loading..",
        widthAdjust: -300
      },
      plotLines: [],
      resetButton: {
        text: "Reset",
        enabled: true,
        onclick: (e) => {
          this.resetSeriesData();
        }
      }
    }
  },

  computed: {
    chartOptions() {

      return {
        credits: { enabled: false },
        chart: {
          marginTop: 160,
          type: 'line',
          zoomType: this.zoomOrDrag == false ? 'x' : false,
          panning: true,
          panKey: 'shift',
          height: 600,
          resetZoomButton: { position: { x: 0, y: -50 } },
          scrollablePlotArea: {
            minWidth: 700,
            scrollPositionX: 1
          },
        },
        exporting: {
          buttons: {
            contextButton: { enabled: false },
            exportButton: { text: 'Export', menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG'] },
            printButton: { text: 'Print', onclick: function () { this.print(); } },
            resetButton: this.resetButton
          },
          filename: this.exportFileName
        },
        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
        series: this.series,
        xAxis: {
          min: this.xMin,
          max: this.xMax,
          type: 'datetime',
          dateTimeLabelFormats: {
            millisecond: '%H:%M:%S.%L',
            second: '%H:%M:%S',
            minute: '%H:%M',
            hour: '%H:%M',
            day: '<span style="fill: #00A04C; font-weight:600">%e %b</span>',
            week: '%e %b',
            month: '%b %Y',
            year: '%Y'
          },
          tickPosition: 'inside',
          labels: {
            rotation: -45,
          },
          crosshair: true,

          events: {
            setExtremes: function (e) {
              var c = this;
              setTimeout(function () {
                if (typeof e.min == 'undefined' && typeof e.max == 'undefined') {
                  // 'zoom-reset'
                  c.chart.yAxis[0].setExtremes(c.chart.yAxis[0].min, c.chart.yAxis[0].max);
                } else {
                  // 'zoom-in'
                  c.chart.yAxis[0].setExtremes();
                }
              }, 1);
            },
            afterSetExtremes: this.afterSetExtremes
          }

        },
        yAxis: {
          tickInterval: 1,
          max: this.yMax,
          min: this.yMin,
          minPadding: 0,
          maxPadding: 0,
          title: { text: '' },
          plotLines: this.plotLines,
          // labels: {
          //   enabled: this.labelsEnabled
          // },
          visible: this.visible
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom',
          labelFormatter: function () {
            return this.name;
          },
        },
        tooltip: {
          shape: "square",
          headerShape: "callout",
          borderWidth: 0,
          shadow: false,
          useHTML: true,
          positioner: function () {
            return { x: 50, y: 0 };
          },
          split: true,
          distance: 30,
          padding: 5,
          formatter() {
            let s = "";
            s = '<span class="date_of_reading" style="color:#444;">' + Highcharts.dateFormat('%A, %b %e %Y, %H:%M:%S', new Date(this.x)) + '</span><br>';
            this.points.forEach(function (point) {

              var series_y = point.y;
              let series_name = point.series.name;

              if (series_name.includes("Battery")) {
                series_y = parseFloat(point.y).toFixed(3);
              }

              else if (series_name.includes("Temp")) {
                series_y = parseFloat(point.y).toFixed(1);
                if (series_name == "Ambient Temperatures") {
                  series_y = Math.trunc(point.y);
                }
              }

              else {
                series_y = parseFloat(point.y).toFixed(2);
              }

              s += '<span style="color:' + point.series.color + '; font-size:13px;">●</span> <span style="color:#444;font-size:13px;font-weight:bold">' + point.series.name + ': </span><span style="color:firebrick;">' + series_y + '</span> <img src="https://img.icons8.com/ios-filled/15/000000/vertical-line.png"/> ';
              if (point.series.name == 'Average' && point.point.status) {
                s += '<span style="color:orange;">●</span> Status: <strong>' + point.point.status + '%</strong><br>';
              }
            });
            return s;
          },
          shared: true,
          // valueDecimals: 2,
        },
        plotOptions: this.plotOptions,
        title: this.chartTitle,
        responsive: {
          rules: [{
            condition: {
              maxWidth: 800,
            },
            chartOptions: {
              legend: {
                enabled: true,
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
                labelFormatter: function () {
                  return this.name;
                },
                x: 0,
                y: 0
              },
            }
          }],
        },
      }
    },

  },

  watch: {
    title: function (val) {
      this.chartOptions.title = val;
    },
    plotOptions: {
      handler: function (val) {
        if (val.length) {
          this.chartOptions.plotOptions = val;
        }
      },
      deep: true
    },
    series: {
      handler: function (val) {
        if (val.length) {
          this.chartOptions.series = val;
        }
      },
      deep: true
    },
    graph_start_date: function (val) {
      this.changeDateRange();
    },
    graph_type: function (val) {
      this.loadGraphData();
    },
    sub_days: function (val) {
      if (val == 'custom' && !this.graph_start_date) { return; }
      if (val != 'custom') { this.graph_start_date = ''; }
      // Experimental
      this.initial_start_date = null;
      this.initial_end_date = null;
      this.loadGraphData();
    },
    current_node: function (val) {
      this.bNotified = false;
      this.loadGraphData();
    }
  },

  methods: {
    addWeighting(key) {
      //console.log(key);
      //console.log(val);
   /*   if (val == 'M0_1') this.vals.M0_1 = key;
      if (val == 'M0_2') this.vals.M0_2 = key;
      if (val == 'M0_3') this.vals.M0_3 = key;
      if (val == 'M0_4') this.vals.M0_4 = key;*/

  },
  calculateWeightingSM() {

      let num = 0;

      if (this.sensor_config.SM1_ENABLED) {
          if (this.sensor_config.SM1_TOGGLE)
              num++;
      }

      if (this.sensor_config.SM2_ENABLED) {
          if (this.sensor_config.SM2_TOGGLE)
              num++;
      }

      if (this.sensor_config.SM3_ENABLED) {
          if (this.sensor_config.SM3_TOGGLE)
              num++;
      }

      if (this.sensor_config.SM4_ENABLED) {
          if (this.sensor_config.SM4_TOGGLE)
              num++;
      }

      if (this.sensor_config.SM5_ENABLED) {
          if (this.sensor_config.SM5_TOGGLE)
              num++;
      }

      if (this.sensor_config.SM6_ENABLED) {
          if (this.sensor_config.SM6_TOGGLE)
              num++;
      }

      if (this.sensor_config.SM7_ENABLED) {
          if (this.sensor_config.SM7_TOGGLE)
              num++;
      }

      if (this.sensor_config.SM8_ENABLED) {
          if (this.sensor_config.SM8_TOGGLE)
              num++;
      }

      if (this.sensor_config.SM9_ENABLED) {
          if (this.sensor_config.SM9_TOGGLE)
              num++;
      }

      if (this.sensor_config.SM10_ENABLED) {
          if (this.sensor_config.SM10_TOGGLE)
              num++;
      }

      if (this.sensor_config.SM11_ENABLED) {
          if (this.sensor_config.SM11_TOGGLE)
              num++;
      }

      if (this.sensor_config.SM12_ENABLED) {
          if (this.sensor_config.SM12_TOGGLE)
              num++;
      }

      if (this.sensor_config.SM13_ENABLED) {
          if (this.sensor_config.SM13_TOGGLE)
              num++;
      }

      if (this.sensor_config.SM14_ENABLED) {
          if (this.sensor_config.SM14_TOGGLE)
              num++;
      }

      if (this.sensor_config.SM15_ENABLED) {
          if (this.sensor_config.SM15_TOGGLE)
              num++;
      }

      if (this.sensor_config.SM1_ENABLED) {
          if (this.sensor_config.SM1_TOGGLE)
              (this.sensor_config.SM1_WEIGHTING) = 100/num;
      }
      if (this.sensor_config.SM2_ENABLED) {
          if (this.sensor_config.SM2_TOGGLE)
              (this.sensor_config.SM2_WEIGHTING) = 100/num;
      }
      if (this.sensor_config.SM3_ENABLED) {
          if (this.sensor_config.SM3_TOGGLE)
              (this.sensor_config.SM3_WEIGHTING) = 100/num;
      }
      if (this.sensor_config.SM4_ENABLED) {
          if (this.sensor_config.SM4_TOGGLE)
              (this.sensor_config.SM4_WEIGHTING) = 100/num;
      }
      if (this.sensor_config.SM5_ENABLED) {
          if (this.sensor_config.SM5_TOGGLE)
              (this.sensor_config.SM5_WEIGHTING) = 100/num;
      }
      if (this.sensor_config.SM6_ENABLED) {
          if (this.sensor_config.SM6_TOGGLE)
              (this.sensor_config.SM6_WEIGHTING) = 100/num;
      }
      if (this.sensor_config.SM7_ENABLED) {
          if (this.sensor_config.SM7_TOGGLE)
              (this.sensor_config.SM7_WEIGHTING) = 100/num;
      }
      if (this.sensor_config.SM8_ENABLED) {
          if (this.sensor_config.SM8_TOGGLE)
              (this.sensor_config.SM8_WEIGHTING) = 100/num;
      }
      if (this.sensor_config.SM9_ENABLED) {
          if (this.sensor_config.SM9_TOGGLE)
              (this.sensor_config.SM9_WEIGHTING) = 100/num;
      }
      if (this.sensor_config.SM10_ENABLED) {
          if (this.sensor_config.SM10_TOGGLE)
              (this.sensor_config.SM10_WEIGHTING) = 100/num;
      }
      if (this.sensor_config.SM11_ENABLED) {
          if (this.sensor_config.SM11_TOGGLE)
              (this.sensor_config.SM11_WEIGHTING) = 100/num;
      }
      if (this.sensor_config.SM12_ENABLED) {
          if (this.sensor_config.SM12_TOGGLE)
              (this.sensor_config.SM12_WEIGHTING) = 100/num;
      }
      if (this.sensor_config.SM13_ENABLED) {
          if (this.sensor_config.SM13_TOGGLE)
              (this.sensor_config.SM13_WEIGHTING) = 100/num;
      }
      if (this.sensor_config.SM14_ENABLED) {
          if (this.sensor_config.SM14_TOGGLE)
              (this.sensor_config.SM14_WEIGHTING) = 100/num;
      }
      if (this.sensor_config.SM15_ENABLED) {
          if (this.sensor_config.SM15_TOGGLE)
              (this.sensor_config.SM15_WEIGHTING) = 100/num;
      }
    },
    saveSensorConfigSM() {
        this.loading = true;

        console.log(this.sensor_config);
        return this.$axios.post("/api/SensorConfigSaveSM", {
            node_address: this.current_node,
            SM1_TOGGLE: this.sensor_config.SM1_TOGGLE,
            SM2_TOGGLE: this.sensor_config.SM2_TOGGLE,
            SM3_TOGGLE: this.sensor_config.SM3_TOGGLE,
            SM4_TOGGLE: this.sensor_config.SM4_TOGGLE,
            SM5_TOGGLE: this.sensor_config.SM5_TOGGLE,
            SM6_TOGGLE: this.sensor_config.SM6_TOGGLE,
            SM7_TOGGLE: this.sensor_config.SM7_TOGGLE,
            SM8_TOGGLE: this.sensor_config.SM8_TOGGLE,
            SM9_TOGGLE: this.sensor_config.SM9_TOGGLE,
            SM10_TOGGLE: this.sensor_config.SM10_TOGGLE,
            SM11_TOGGLE: this.sensor_config.SM11_TOGGLE,
            SM12_TOGGLE: this.sensor_config.SM12_TOGGLE,
            SM13_TOGGLE: this.sensor_config.SM13_TOGGLE,
            SM14_TOGGLE: this.sensor_config.SM14_TOGGLE,
            SM15_TOGGLE: this.sensor_config.SM15_TOGGLE,
            SM1_WEIGHTING: this.sensor_config.SM1_WEIGHTING,
            SM2_WEIGHTING: this.sensor_config.SM2_WEIGHTING,
            SM3_WEIGHTING: this.sensor_config.SM3_WEIGHTING,
            SM4_WEIGHTING: this.sensor_config.SM4_WEIGHTING,
            SM5_WEIGHTING: this.sensor_config.SM5_WEIGHTING,
            SM6_WEIGHTING: this.sensor_config.SM6_WEIGHTING,
            SM7_WEIGHTING: this.sensor_config.SM7_WEIGHTING,
            SM8_WEIGHTING: this.sensor_config.SM8_WEIGHTING,
            SM9_WEIGHTING: this.sensor_config.SM9_WEIGHTING,
            SM10_WEIGHTING: this.sensor_config.SM10_WEIGHTING,
            SM11_WEIGHTING: this.sensor_config.SM11_WEIGHTING,
            SM12_WEIGHTING: this.sensor_config.SM12_WEIGHTING,
            SM13_WEIGHTING: this.sensor_config.SM13_WEIGHTING,
            SM14_WEIGHTING: this.sensor_config.SM14_WEIGHTING,
            SM15_WEIGHTING: this.sensor_config.SM15_WEIGHTING
          }).then(resp => {
            this.loadGraphData();
            this.loading = false;
        });
    },
    loadSensorConfigSM() {

    this.loading = true;
    this.$axios.get("/api/SensorConfigLoadSM/" + this.current_node)
        .then((resp) => {
        console.log(resp.data);
            this.sensor_config.SM1_TOGGLE = resp.data[1].SM1_TOGGLE ? true : false;
            this.sensor_config.SM2_TOGGLE = resp.data[1].SM2_TOGGLE ? true : false;
            this.sensor_config.SM3_TOGGLE = resp.data[1].SM3_TOGGLE ? true : false;
            this.sensor_config.SM4_TOGGLE = resp.data[1].SM4_TOGGLE ? true : false;
            this.sensor_config.SM5_TOGGLE = resp.data[1].SM5_TOGGLE ? true : false;
            this.sensor_config.SM6_TOGGLE = resp.data[1].SM6_TOGGLE ? true : false;
            this.sensor_config.SM7_TOGGLE = resp.data[1].SM7_TOGGLE ? true : false;
            this.sensor_config.SM8_TOGGLE = resp.data[1].SM8_TOGGLE ? true : false;
            this.sensor_config.SM9_TOGGLE = resp.data[1].SM9_TOGGLE ? true : false;
            this.sensor_config.SM10_TOGGLE = resp.data[1].SM10_TOGGLE ? true : false;
            this.sensor_config.SM11_TOGGLE = resp.data[1].SM11_TOGGLE ? true : false;
            this.sensor_config.SM12_TOGGLE = resp.data[1].SM12_TOGGLE ? true : false;
            this.sensor_config.SM13_TOGGLE = resp.data[1].SM13_TOGGLE ? true : false;
            this.sensor_config.SM14_TOGGLE = resp.data[1].SM14_TOGGLE ? true : false;
            this.sensor_config.SM15_TOGGLE = resp.data[1].SM16_TOGGLE ? true : false;

            this.sensor_config.SM1_WEIGHTING = resp.data[1].SM1_WEIGHTING;
            this.sensor_config.SM2_WEIGHTING = resp.data[1].SM2_WEIGHTING;
            this.sensor_config.SM3_WEIGHTING = resp.data[1].SM3_WEIGHTING;
            this.sensor_config.SM4_WEIGHTING = resp.data[1].SM4_WEIGHTING;
            this.sensor_config.SM5_WEIGHTING = resp.data[1].SM5_WEIGHTING;
            this.sensor_config.SM6_WEIGHTING = resp.data[1].SM6_WEIGHTING;
            this.sensor_config.SM7_WEIGHTING = resp.data[1].SM7_WEIGHTING;
            this.sensor_config.SM8_WEIGHTING = resp.data[1].SM8_WEIGHTING;
            this.sensor_config.SM9_WEIGHTING = resp.data[1].SM9_WEIGHTING;
            this.sensor_config.SM10_WEIGHTING = resp.data[1].SM10_WEIGHTING;
            this.sensor_config.SM11_WEIGHTING = resp.data[1].SM11_WEIGHTING;
            this.sensor_config.SM12_WEIGHTING = resp.data[1].SM12_WEIGHTING;
            this.sensor_config.SM13_WEIGHTING = resp.data[1].SM13_WEIGHTING;
            this.sensor_config.SM14_WEIGHTING = resp.data[1].SM14_WEIGHTING;
            this.sensor_config.SM15_WEIGHTING = resp.data[1].SM15_WEIGHTING;

            this.sensor_config.SM1_ENABLED = resp.data[0].sensor_placing_1 == 'on'? true : false;
            this.sensor_config.SM2_ENABLED = resp.data[0].sensor_placing_2 == 'on' ? true : false;
            this.sensor_config.SM3_ENABLED = resp.data[0].sensor_placing_3 == 'on' ? true : false;
            this.sensor_config.SM4_ENABLED = resp.data[0].sensor_placing_4  == 'on'? true : false;
            this.sensor_config.SM5_ENABLED = resp.data[0].sensor_placing_5 == 'on' ? true : false;
            this.sensor_config.SM6_ENABLED = resp.data[0].sensor_placing_6 == 'on' ? true : false;
            this.sensor_config.SM7_ENABLED = resp.data[0].sensor_placing_7  == 'on'? true : false;
            this.sensor_config.SM8_ENABLED = resp.data[0].sensor_placing_8  == 'on'? true : false;
            this.sensor_config.SM9_ENABLED = resp.data[0].sensor_placing_9  == 'on'? true : false;
            this.sensor_config.SM10_ENABLED = resp.data[0].sensor_placing_10  == 'on'? true : false;
            this.sensor_config.SM11_ENABLED = resp.data[0].sensor_placing_11  == 'on'? true : false;
            this.sensor_config.SM12_ENABLED = resp.data[0].sensor_placing_12 == 'on' ? true : false;
            this.sensor_config.SM13_ENABLED = resp.data[0].sensor_placing_13 == 'on' ? true : false;
            this.sensor_config.SM14_ENABLED = resp.data[0].sensor_placing_14 == 'on' ? true : false;
            this.sensor_config.SM15_ENABLED = resp.data[0].sensor_placing_15 == 'on' ? true : false;

            console.log(this.sensor_config);

            this.loading = false;
            });
    },
    loadGraphData() {

      this.loading = true;
      this.in_progress = true;

      this.$refs.hchart.chart.showLoading(this.bInitialQuery ? "Loading..." : "Refreshing...");
          console.log(this.graph_type);
      return this.$axios.post("/api/Graph", {
        node_address: this.current_node,
        graph_type: this.graph_type,
        graph_start_date: this.graph_start_date,
        sub_days: this.sub_days,
        is_initial: this.bInitialQuery,
        selection_start: this.selection_start,
        selection_end: this.selection_end
      }).then(resp => {

        this.loading = false;
        this.in_progress = true;
        this.$refs.hchart.chart.hideLoading();


        if (resp.data) {
          if (resp.data.message && resp.data.message == 'no_data') {
            swal.fire({
              title: 'No data found',
              text: "This node currently has no data to plot.",
              showCancelButton: false,
              confirmButtonText: 'OK',
              buttonsStyling: false,
              customClass: {
                cancelButton: 'btn btn-outline-primary',
                confirmButton: 'btn btn-primary'
              }
            });
            this.chartTitle.text = "No data found";
            //setTimeout(() => { this.in_progress = false; }, 1);
            return;
          }

          if (!this.bNotified && resp.data.not_current && resp.data.last_date) {
            swal.fire({
              title: 'No recent data found',
              text: "Last readings up to " + resp.data.last_date + " could be displayed.",
              showCancelButton: false,
              confirmButtonText: 'OK',
              buttonsStyling: false,
              customClass: {
                cancelButton: 'btn btn-outline-primary',
                confirmButton: 'btn btn-primary'
              }
            });
            this.bNotified = true;
          }

          this.selection_start = null;
          this.selection_end = null;

          // COMMON DATA
          this.node_id = resp.data.node_id;
          this.field_name = resp.data.field_name;
          // Experimental
          if (this.bInitialQuery) {
            this.graph_start_date = resp.data.graph_start_date;
            this.graph_type = resp.data.graph_type;
            this.sub_days = resp.data.sub_days;
          }
          this.xMax = resp.data.x_max;
          this.xMin = resp.data.x_min;
          //this.yMin = resp.data.y_min;


          if (this.graph_type == 'ave') {
            this.yMax = resp.data.y_max;
            this.yMin = resp.data.y_min;
          } else {
            this.yMax = null;
            this.yMin = null;
          }

          if (this.graph_type == 'stack') {
            this.reversed = false;
          }
          // else {
          //   this.reversed = false;
          // }

          this.yMaxBackup = resp.data.y_max; // used with toggle switch
          this.yMinBackup = resp.data.y_min; // used with toggle switch

          this.full = resp.data.full;
          this.refill = resp.data.refill;

          this.lastDate = resp.data.last_date.replace(":", '-');
          this.exportFileName = resp.data.graph.field_name + '-' + this.graph_type + '-' + this.$route.params.node_address + '-' + this.lastDate;

          this.plotOptions = resp.data.graph.plotOptions;
          this.chartTitle = resp.data.graph.title;

          this.series = resp.data.graph.series.filter((series) => { if (series.data) { return series.data.length > 0; } else return false; });

          this.lastTimestamp = resp.data.x_max;

          if (this.graph_type == 'sm' || this.graph_type == 'stack') {
            if (this.zoomOrDrag) {
              this.enableSeriesDragDrop();
            } else {
              this.disableSeriesDragDrop();
            }
          } else {
            this.disableSeriesDragDrop();
          }

          // if (this.graph_type == 'stack') {
          //   console.log('stack found');

          //   if (this.zoomOrDrag) {
          //   console.log('stack found2');

          //     this.enableSeriesDragDrop();
          //   } else {
          //   console.log('stack found3');

          //     this.disableSeriesDragDrop();
          //   }

          // } else {
          //   this.disableSeriesDragDrop();
          // }

          if (this.graph_type == 'ave') {
            this.showPlotLines();
            //this.formatTooltip();
            this.setupCustomTooltip();
          } else {
            this.hidePlotLines();
            this.removeCustomTooltip();
          }

          this.related_nodes = resp.data.related_nodes;
          this.$refs.hchart.chart.reflow();

          if (this.graph_type == 'stack') {
            this.visible = false;
            this.plotOptions.series.stacking = this.stacking;
          } else {
            this.visible = true;
            this.plotOptions.series.stacking = null;
          }

          

        }
        setTimeout(() => { this.in_progress = false; this.bInitialQuery = false; }, 1);
        return resp;
      });
    },

    maybeReloadGraphData() {
      if (this.in_progress == true) { return; }
      this.loadGraphData();
    },

    changeDateRange() {

      if (this.in_progress == true) { return; }
      if (this.graph_start_date == '') { return; }
      this.loadGraphData();
    },

    enableSeriesDragDrop() {
      if (this.series && this.series.length) {
        // console.log("Enabling Series Drag and Drop");
        // console.log(this.series);

        if (this.graph_type == 'stack') {
          // Remove labels on yAxis when DnD is true
          this.labelsEnabled = false;

          this.chartOptions.yAxis.visible = false;
        } else {
          this.labelsEnabled = true;
        }

        // Enable shared tooltip
        this.chartOptions.tooltip = { shared: true };
        // Enable custom Reset button
        this.resetButton.enabled = true;

        this.series.forEach((series, idx) => {

          // Set custom Per Series Data
          this.series[idx].custom = {
            moved: false
          };

          this.series[idx].pointStart = Date.UTC(2004, 3, 1);
          this.series[idx].pointInterval = 3600 * 1000;

          // Enable DnD for this range of series only
          this.series[idx].dragDrop = {
            draggableX: false,
            draggableY: true,
            dragMinY: 0,
            dragMaxY: 100,
            groupBy: 'grp',
          };

          this.series[idx].dragDrop.draggableX = false;
          this.series[idx].dragDrop.draggableY = true;
          if (this.series[idx].name != 'Average') {
            this.series[idx].dragDrop.groupBy = 'grp' + (idx + 1);
          } else {
            this.series[idx].dragDrop.groupBy = 'grpavg';
          }

          // Track changes
          this.series[idx].point = {
            events: {
              dragStart: function () {
                this.series.options.custom.moved = true;
              },
            }
          };

          // Format tooltip: Hide value once series was moved
          this.series[idx].tooltip = {

            pointFormatter: function () {
              return '<span style="color:' + this.series.color + ';">●</span> ' + this.series.name + ': <b>' +
                (this.series.options.custom.moved ? '' : Highcharts.numberFormat(this.y, 2)) + '</b><br/>';
            }
          };
        });
        // Lock in Y Max/Min
        // if(this.graph_type != 'ave'){
        //   this.yMax = this.yMaxBackup;
        //   this.yMin = this.yMinBackup;
        // }

        // Lock in Y Max/Min
        if (this.graph_type != 'ave') {
          //console.log(this.$refs.hchart);
          this.yMax = this.$refs.hchart.chart.yAxis[0].max;
          this.yMin = this.$refs.hchart.chart.yAxis[0].min;
        }

        this.chartTriggerChange();
      }
    },

    disableSeriesDragDrop() {
      if (this.series && this.series.length) {
        //console.log("Disabling series DnD");

        // Disable drag
        this.series.forEach((series, idx) => {
          // if(typeof(this.series[idx].dragDrop) === "undefined"){
          this.series[idx].dragDrop = {
            draggableX: false,
            draggableY: false,
            groupBy: this.series[idx].name == 'Average' ? 'grpavg' : ('grp' + (idx + 1))
          };
          // } else {
          //   this.series[idx].dragDrop.draggableX = false;
          //   this.series[idx].dragDrop.draggableY = false;
          // }
          // this.series[idx].dragDrop.draggableX = false;
          // this.series[idx].dragDrop.draggableY = false;

          this.series[idx].pointStart = Date.UTC(2004, 3, 1);
          this.series[idx].pointInterval = 3600 * 1000;
        });

        // Enable labels on yAxis when DnD is false
        this.labelsEnabled = true;

        // Disable shared tooltip
        this.chartOptions.tooltip = { shared: false };
        // Disable custom Reset button
        this.resetButton.enabled = false;

        // Disable Y Max/Min
        if (this.graph_type != 'ave') {
          this.yMax = null;
          this.yMin = null;
        }

        this.chartTriggerChange();
      }
    },

    toggleSeriesDragDrop() {
      // Zoom
      if (this.zoomOrDrag) {
        this.enableSeriesDragDrop();
        // Drag
      } else {
        this.disableSeriesDragDrop();
      }
    },

    // toggleStacking()
    // {
    //   console.log('Toggle Stacking');
    //   this.plotOptions.series.stacking = this.stacking;
    //   this.chartTriggerChange();
    // },

    showPlotLines() {
      this.plotLines = [
        { /* Full Line */
          value: this.full,
          color: '#00F',
          width: 2,
          label: {
            x: 0,
            align: 'right',
            formatter: () => { return 'Full: ' + this.full; }
          }
        },
        { /* Refill Line */
          value: this.refill,
          color: '#D26761',
          width: 2,
          label: {
            x: 0,
            align: 'right',
            formatter: () => { return 'Refill: ' + this.refill; }
          }
        }
      ];
    },

    hidePlotLines() {
      this.plotLines = [];
    },

    // Hack to trigger chart update via faux change
    chartTriggerChange() {
      // console.log('hi');
      this.series.push({ type: 'line', name: 'Faux', data: [] });
      this.series.pop();
    },

    exportGraphCSV() {

      this.zoomOrDrag = false;

      // accessing internal series data from the outside
      let series = this.$refs.hchart.chart.series;
      try {
        for (var i = 0; i < series.length; i++) {
          if (typeof series[i].options.custom.moved !== "undefined") {
            if (series[i].options.custom.moved == true) {
              this.seriesAdjusted = true;
              break;
            }
          }
        }
      } catch (err) { }

      if (this.seriesAdjusted) {
        this.resetSeriesData().then((resp) => {
          this.$refs.hchart.chart.downloadCSV();
        });
      } else {
        this.$refs.hchart.chart.downloadCSV();
      }
    },

    resetSeriesData() {
      this.seriesAdjusted = false;
      return this.loadGraphData();
    },

    formatTooltip() {
      // let s = "";
      // s = '<span class="date_of_reading" style="color:#444;">' + Highcharts.dateFormat('%A, %b %e %Y, %H:%M:%S', new Date(this.x)) + '</span><br>';
      // this.series.forEach(function (point) {
      //   console.log(point);
      //   s += '<span style="color:' + point.color + '; font-size:13px;">●</span> <span style="color:#444;font-size:13px;font-weight:bold">' + point.name + ': </span><span style="color:firebrick;">' + point.y + '</span> <img src="https://img.icons8.com/ios-filled/15/000000/vertical-line.png"/> ';
      //   if (point.name == 'Average' && point.status) {
      //     s += '<span style="color:black;">●</span> Status: <strong>' + point.status + '%</strong><br>';
      //   }
      // });
      // return s;
      for (var i = 0; i < this.series.length; i++) {
        // if (this.series[i].name == 'Average') {
        //console.log(this.series[i]);
        this.series[i].tooltip = {
          pointFormatter: function () {
            //let str = '<span style="color:' + this.series.color + ';">●</span> ' + this.series.name + ': <b>' + this.y + '</b><br>';
            let str = '<span class="date_of_reading" style="color:#444;">' + Highcharts.dateFormat('%A, %b %e %Y, %H:%M:%S', new Date(this.x)) + '</span><br>';
            str += '<span style="color:' + this.series.color + '; font-size:13px;">●</span> <span style="color:#444;font-size:13px;font-weight:bold">' + this.series.name + ': </span><span style="color:firebrick;">' + this.y + '</span> <img src="https://img.icons8.com/ios-filled/15/000000/vertical-line.png"/> ';

            if (this.series.name == 'Average' && this.status) {
              //str += '<span style="color:orange;">●</span> Status: <strong>' + this.status + '%</strong><br>';
              str += '<span style="color:orange; font-size:13px;">●</span> <span style="color:#444;font-size:13px;font-weight:bold">Status : </span><span style="color:firebrick;">' + this.status;
            }
            return str;
          }
        };
        // }
      }
    },


    setupCustomTooltip() {
      for (var i = 0; i < this.series.length; i++) {
        if (this.series[i].name == 'Average') {
          this.series[i].tooltip = {
            pointFormatter: function () {
              let str = '<span style="color:' + this.series.color + ';">●</span> ' + this.series.name + ': <b>' + this.y + '</b><br>';
              if (this.series.name == 'Average' && this.status) {
                str += '<span style="color:black;">●</span> Status: <strong>' + this.status + '%</strong><br>';
              }
              return str;
            }
          };
        }
      }
    },

    removeCustomTooltip() {
      for (var i = 0; i < this.series.length; i++) {
        if (this.series[i].tooltip && this.series[i].tooltip.pointFormatter) {
          delete this.series[i].tooltip.pointFormatter;
        }
      }
    },

    goToManage() {
      this.$router.push({
        name: 'soil_moisture_edit',
        params: { node_address: this.current_node }
      });
    },

    afterSetExtremes(e) {
      // initial load
      if (e.trigger == null) {
        if (this.bInitialQuery) {
          this.initial_start_date = this.xMin;
          this.initial_end_date = this.xMax;
          this.bInitialQuery = false;
        }
      } else {
        if (e.target.chart.resetZoomButton) {
          this.selection_start = e.min;
          this.selection_end = e.max;
        } else {
          this.selection_start = this.initial_start_date;
          this.selection_end = this.initial_end_date;
        }
        this.maybeReloadGraphData();
      }
    }
  },

  created() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    this.date_now = today = yyyy + '-' + mm + '-' + dd;
  },

  mounted() {
    this.loadSensorConfigSM();
    this.loadGraphData();
  }

};
</script>
<style>
.highcharts-tooltip {
  pointer-events: auto !important;
}

/* .highcharts-tooltip-container .highcharts-tooltip>span {
  min-width: 400px;
  max-width: 400px;
  white-space: normal;
  overflow-y:scroll !important;
  height:auto !important;
  white-space:normal !important; 
}

.highcharts-tooltip span {
    height:auto !important;
    width:400px !important;
    max-width:400px !important;
    overflow-y:scroll !important;
    white-space:normal !important; 
} */

/* .the_graph .highcharts-container {
  height: 800px !important;
} */

/* .highcharts-background {
  height:800px !important;


} */

/* .highcharts-tooltip-box span:first-child {
  font-size: 15px;
  color: #fff;
  white-space: nowrap;
  white-space: normal !important;
  margin: 4px, 4px;
  padding: 18px;
  background-color: #fff;
  right: 8px !important;
  margin: 0 auto !important;
  top: 0 !important;
  text-align: center;
  border-radius: 2px;
}  */

.highcharts-tooltip-box span:first-child {
  font-size: 15px;
  color: #fff;
  white-space: nowrap;
  white-space: normal !important;
  margin: 4px, 4px;
  padding: 18px;
  background-color: transparent;
  right: 8px !important;
  /* margin: 0 auto!important; */
  top: -5px !important;
  text-align: center;
  border-radius: 2px;
  padding-bottom: 0 !important;
}

/* .highcharts-tooltip-box,
.highcharts-tooltip {
  right: 0 !important;
  margin: 0 auto !important;
  left: 0 !important;
} */

.highcharts-tooltip,
.highcharts-tooltip-box {
  /* right: 0!important; */
  margin: 0 auto !important;
  /* left: 0!important; */
  width: 97%;
  top: 0px !important;
  text-align: center;
}

/* .highcharts-tooltip-box {
  top: 125px !important;
} */

.highcharts-tooltip {
  top: 30px !important;
}

.highcharts-label-box {
  fill: transparent;
}

.date_of_reading {
  color: #333 !important;
  text-align: center !important;
  display: block;
  position: sticky;
  padding: 5px !important;
  border: 0 !important;
  /* font-weight: bold; */
  padding-top: 8px !important;
}

.graph_margin {
  margin-top: -100px;
}

@media only screen and (max-width: 800px) {

  .date_of_reading {
    /* position: absolute !important; */
    text-align: center !important;
    display: block;
    width: 100% !important;
    padding-bottom: 2px !important;
    border-left: 0px solid #666 !important;
    border-top: 1px solid #666 !important;
    border-right: 0px solid #666 !important;
    border-bottom: 0 !important;
    background: transparent;
    margin-bottom: 10px !important;
  }

  .graph_margin {
    margin-top: 0px;
  }

  .highcharts-tooltip-box span:first-child {
    width: 100% !important;
    right: 5px !important;
    left: 0px !important;
    text-align: center;
    padding: 15px;
    width: auto;
    top: 88px !important;
    position: fixed !important;
    border-top: 1px solid #666;
    border-bottom: 1px solid #666;
    background-color: white !important;
  }

  .highcharts-tooltip-box {
    top: 70px !important;
  }
}

.modal-title {
  font-size: 2.0625rem;
}
</style>
